<template>
  <v-app>
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-12">


          <v-container fluid>
            <v-card elevation="2" outlined>
              <v-card-title>
                <!--                                    v-if="$can('transaction_create')"-->
                <v-btn :to="{name: 'pack-properties.create'}" rounded color="#308BB0" class="text-white">
                  <v-icon>mdi-plus</v-icon>
                  افزودن
                </v-btn>
                <v-spacer/>
                {{ $route.meta.title }}
                <v-spacer/>
                <v-btn :loading="loading" @click="reloadTable" color="primary" rounded
                       class="text-white">
                  <v-icon>mdi-refresh</v-icon>
                  به روزرسانی
                </v-btn>

              </v-card-title>
              <v-divider/>
              <div class="row">
                <div class="col-md-12 p-5">
                  <data-table
                      :data="data"
                      :columns="columns"
                      :debounce-delay="5000"
                      :translate="translate"
                      :per-page="[10, 25, 50, 100, 400]"
                      @on-table-props-changed="reloadTable"
                  >
                  </data-table>

                </div>
              </div>

            </v-card>

          </v-container>


        </div>
      </div>

    </div>

  </v-app>

</template>

<script >
  import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
  import Btn from "@/view/pages/categories/Btn";

  export default {
    data() {
      return {
        data: {},
        url: 'packProperties/',
        loading: false,
        translate: {
          nextButton: 'بعدی',
          previousButton: 'قبلی',
          rowsPerPageText: 'تعداد در صفحه',
          noDataText: 'داده ای برای نمایش وجود ندارد',
          placeholderSearch: 'جستجو',
        },
        tableProps: {
          search: '',
          length: 10,
          column: 'id',
          dir: 'desc',
        },
        columns: [
          {
            name: 'id',
            label: 'شناسه',
            orderable: true,
          },
          {
            name: 'title',
            label: 'نام',
            orderable: true,
            searchable: true,
          },
          {
            name: 'price',
            label: 'قیمت',
            orderable: true,
            searchable: true,
          },
          {
            name: 'type',
            label: 'نوع',
            transform: (value) => {
              return value.data.type === 'sms' ? 'پیامک' : 'مترادف';
            }
          },
          {
            name: 'created_at',
            label: 'تاریخ ایجاد',
          },
          {
            name: 'actions',
            label: 'عملیات',
            handler: this.actions,
            component: Btn,
            event: 'action',
            meta: {
              permission_prefix: 'pack-properties_',
            }
          }
        ],
      }
    },
    created() {
      this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
      this.getPackProperties(this.url)
    },

    methods: {
      reloadTable(tableProps){
        this.getPackProperties(this.url, tableProps)
      },

      getPackProperties(url = this.url, query = this.tableProps) {
        this.loading = true;
        this.requestApiGet(url, query).then(response => {
          this.data = response.data;
          this.loading = false;
        })
      },

      actions(data, type) {
        this[type](data);
      },

      edit(data) {
        return this.$router.push({name: 'pack-properties.edit', params: {id: data.id}})
      },

      delete(data) {
        this.$swal({
          title: 'حذف شود؟',
          text: 'بعد از حذف امکان بازگشت وجود ندارد',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'بله',
          cancelButtonText: 'خیر'
        }).then((result) => {
          if (result.value) {
            this.requestApiDelete(this.url+ data.id).then(response => {
              this.$swal({
                title: 'حذف شد',
                text: 'محصول با موفقیت حذف شد',
                icon: 'success',
                confirmButtonText: 'تایید'
              }).then(() => {
                this.getPackProperties(this.url)
              })
            })
          }
        })
      },



    }

  }
</script>